import { CheckboxOption } from 'shared/common/ConvertToCheckboxOptions'
import { useFilter } from 'shared/common/OpenFiltersButton/hooks/useFilter'
import { ParamKey } from 'shared/types/QueryModel'

import { useEffect, useState } from 'react'

import {
  useGetCompaniesQuery,
  useLazyGetBranchesQuery,
} from 'modules/Orders/services/ordersApi'

interface Props {
  queryKeys: ParamKey[]
}
export const useBrandBranch = ({ queryKeys }: Props) => {
  const { data: brands, isFetching: isFetchingBrands } = useGetCompaniesQuery({
    params: { is_crm: 'true' },
  })
  const [getBranches, { isFetching: isFetchingBranches }] =
    useLazyGetBranchesQuery()

  const { filters } = useFilter()

  const [brandOptions, setBrandOptions] = useState<CheckboxOption[]>([])
  const [branchOptions, setBranchOptions] = useState<CheckboxOption[]>([])

  useEffect(() => {
    if (brands?.success) {
      setBrandOptions(
        brands.result.map((brand) => ({
          label: brand.name,
          value: brand.slug,
        })),
      )
    }
  }, [brands])

  const handleGetBranches = async () => {
    if (filters?.[queryKeys[0]]) {
      const branches = await getBranches({
        params: {
          company__slug: filters?.[queryKeys[0]],
        },
      }).unwrap()
      setBranchOptions(
        branches.result.map((branch) => ({
          label: branch.title,
          value: branch.slug,
        })),
      )
    }
  }

  useEffect(() => {
    setBranchOptions([])
    handleGetBranches()
  }, [filters?.[queryKeys[0]]])

  return {
    isFetchingBrands,
    isFetchingBranches,
    brandOptions,
    branchOptions,
  }
}
